import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import { PageHero, SectionHeader, EmeraldButton } from "@/components/Bits";
import { LIFESTYLE } from "@/lib/brand";

const upcoming = [
  {
    cat: "Article",
    title: "The Hidden Cost of Digital Overwhelm for High-Performing Professionals",
    excerpt:
      "How the modern workplace's invisible inputs erode focus — and the simplest interventions that restore deep work.",
  },
  {
    cat: "Field Guide",
    title: "A Strategic Approach to Side Income for Federal Professionals",
    excerpt:
      "An ethical, compliant framework for building secondary income while honoring the responsibilities of public service.",
  },
  {
    cat: "Audio",
    title: "Designing Your Exit: A Conversation with Dr. Phelesia Foster",
    excerpt:
      "Dr. Foster walks listeners through the early decisions that determine whether your transition feels chaotic or curated.",
  },
];

const Resources = () => (
  <div data-testid="page-resources">
    <PageHero
      overline="Resources"
      title="Insights, frameworks, and ideas to design your next chapter."
      subtitle="A curated journal of articles, audio, and field guides — published with intention, never on a schedule."
      image={LIFESTYLE.workspace}
    />

    <section className="ess-section bg-ess-paper">
      <div className="ess-container">
        <SectionHeader
          overline="Journal"
          title="A library in the making."
          subtitle="Our journal is currently being developed. Sign up for the free Digital Productivity Resource to be the first to know when new articles, field guides, and audio conversations are released."
          maxWidth="max-w-2xl"
        />
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mt-14">
          {upcoming.map((a) => (
            <article
              key={a.title}
              className="bg-white flex flex-col border border-ess-blush"
              data-testid={`resource-${a.title.toLowerCase().replace(/\W+/g, "-").slice(0, 30)}`}
            >
              <div className="p-7 flex-1 flex flex-col">
                <div className="flex items-center justify-between">
                  <p className="ess-overline">{a.cat}</p>
                  <span className="inline-flex items-center gap-1 text-[10px] uppercase tracking-[0.22em] text-ess-gold-deep border border-ess-gold/40 px-2 py-1">
                    <Clock size={10} /> Coming Soon
                  </span>
                </div>
                <h3 className="font-display text-2xl mt-4 text-ess-emerald leading-tight">
                  {a.title}
                </h3>
                <p className="text-ess-slate text-sm mt-3 leading-relaxed flex-1">
                  {a.excerpt}
                </p>
                <span className="mt-6 inline-flex items-center text-[12px] uppercase tracking-[0.22em] text-ess-charcoal/40">
                  Coming Soon
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>

    <section className="ess-section bg-ess-blush">
      <div className="ess-container grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
        <div>
          <p className="ess-overline">The Quiet Letter</p>
          <h2 className="font-display text-4xl md:text-5xl text-ess-emerald mt-4 leading-tight">
            A monthly letter for professionals designing the next chapter.
          </h2>
          <p className="text-ess-slate mt-5 leading-relaxed">
            One thoughtful note per month. Frameworks, observations, and the
            occasional tool — never noise.
          </p>
        </div>
        <div>
          <EmeraldButton as="link" to="/" data-testid="resources-newsletter-cta">
            Get the Free Blueprint <ArrowRight size={14} className="ml-3" />
          </EmeraldButton>
          <p className="text-xs text-ess-slate/70 mt-3">
            Begin with our Digital Detox Blueprint on the home page.
          </p>
        </div>
      </div>
    </section>
  </div>
);

export default Resources;
